var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.98 0C15.79 0 20 4.74 20 10C20 11.68 19.51 13.41 18.65 14.99C18.49 15.25 18.47 15.58 18.58 15.89L19.25 18.13C19.4 18.67 18.94 19.07 18.43 18.91L16.41 18.31C15.86 18.13 15.43 18.36 14.919 18.67C13.459 19.53 11.64 19.97 10 19.97C5.04 19.97 0 16.14 0 9.97C0 4.65 4.3 0 9.98 0",
    fill: "#3E7EEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0198 11.2896C10.7298 11.2796 11.2998 10.7096 11.2998 9.99962C11.2998 9.29962 10.7198 8.71962 10.0198 8.72962C9.30976 8.72962 8.73976 9.29962 8.73976 10.0096C8.73976 10.7096 9.30976 11.2896 10.0198 11.2896ZM14.6302 11.2896C15.3302 11.2896 15.9102 10.7096 15.9102 10.0096C15.9102 9.29962 15.3402 8.72962 14.6302 8.72962C13.9202 8.72962 13.3502 9.29962 13.3502 10.0096C13.3502 10.7096 13.9202 11.2796 14.6302 11.2896ZM6.68996 10.0096C6.68996 10.7096 6.11996 11.2896 5.40996 11.2896C4.69996 11.2896 4.12996 10.7096 4.12996 10.0096C4.12996 9.29962 4.69996 8.72962 5.40996 8.72962C6.11996 8.72962 6.68996 9.29962 6.68996 10.0096Z",
    fill: "#3E7EEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.0dae865d06158cda4a555a03f8c7e2d2.svg";
export { ForwardRef as ReactComponent };